import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import "../../styles/PaymentLinks.css";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router-dom";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import SearchIcon from "@mui/icons-material/Search";
import StatusFilter from "../../Common/Filters/StatusFilter/statusfilter.jsx";
import DateFilter from "../../Common/Filters/DateFilter/datefilter.jsx";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "../../CommonStyle/Tablestyling.css";
import { ImagesPath } from '../../Common/imagespath/imagespath';
import { data } from "../../Common/Text/NormalText";
import Loaders from "../../components/ReusebleComponents/Loaders";
import axios from "axios";

const PaymentLinks = () => {
  const user = useSelector((state) => state.user.user);
  const [merchantId, setMerchantId] = useState("");
  const [history, setHistory] = useState([]);
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedDate, setSelectedDate] = useState("All");
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [activeFilter, setActiveFilter] = useState(null);
  const [historyLoading, setHistoryLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (currentPage < startPage) {
      setStartPage(currentPage);
    } else if (currentPage >= startPage + 3) {
      setStartPage(currentPage - 2);
    }
  }, [currentPage]);


  useEffect(() => {
    if (user?.MerchantId) {
      setMerchantId(user?.MerchantId);
    }
    if (user && user?.walletStatus?.trim()?.toLowerCase() !== "active" && !user?.allowWalletSettlements?.includes("PAYMENT_LINKS")) {
      navigate('*')
      return;
    }
  }, [user]);

  useEffect(() => {
    fetchPaymentLinktransactions();
  }, [selectedStatus, selectedDate, customStartDate, customEndDate]);

  const handleCopy = (copydata) => {
    navigator.clipboard.writeText(copydata || "");
    toast.success("Copied!");
  };

  const handleShare = (link) => {
    if (link) {
      const url = "https://web.whatsapp.com/";
      window.open(url, "_blank");
    } else {
      alert("Please generate payment link first");
    }
  };

  const fetchPaymentLinktransactions = async () => {
    const token = await GetWebAccessToken();
    const headers = {
      "Cache-Control": "no-cache",
    "Pragma": "no-cache",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await axios.get(
        `${apiUrl}/pl/get/paymentLinkTransactions?filterType=${selectedDate === "All" ? "" : selectedDate
        }&fromDate=${customStartDate}&toDate=${customEndDate}&link_payment_status=${selectedStatus === "All" ? "" : selectedStatus?.toUpperCase()
        }`,
        { headers }
      );
      if (response?.data?.message === "valid") {
        const paymentTransactions = response?.data?.data;
        console.log(
          "after if condition paymentTransactions length ===>",
          paymentTransactions.length
        );
        setHistory(paymentTransactions);
      } else {
        setHistory([]);
      }
    } catch (error) {
      console.log("error while fetching payment link details===>", error);
      setHistory([]);
    } finally {
      
      setHistoryLoading(false);
    }
  };


  const getStatusClass = (status) => {
    return (
      {
        Active: "statusPl paymentlink-active",
        Pending: "statusPl pending",
        Processing: "statusPl processing",
        success: "statusPl Plsuccess",
        SUCCESS: "statusPl Plsuccess",
        failed: "statusPl failed_v",
      }[status] || "statusPl default"
    ); // Default class if status is unknown
  };

  function generateRandomString(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  }

  const randomString = generateRandomString(7);
  const reveredString = generateRandomString(7)
  const Clink = `https://wyto.com/login/NPL/${user ? user?.MerchantId : ""
    }`;
  const copyClink = `https://wyto.com/login/NPL/${randomString}${user ? user?.MerchantId : ""
    }${reveredString}`;


  const recordsPerPageOptions = [10, 25, 50, 100];
  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredHistory = history.filter((item) => {
    const matchesSearch =
      (item?.customerName?.toLowerCase() || "")?.includes(searchQuery.toLowerCase()) ||
      (item?.link_amount?.toString() || "")?.includes(searchQuery.toLowerCase()) ||
      (item?.transactionId?.toLowerCase() || "")?.includes(searchQuery.toLowerCase());

    return matchesSearch;
  });

  const sumAmount = useMemo(
    () =>
      filteredHistory.reduce(
        (acc, curr) =>
          curr?.link_payment_status?.toUpperCase() === "SUCCESS" ||
            curr?.link_payment_status?.toUpperCase() === "PROCESSING"
            ? acc + (curr.link_amount || 0)
            : acc,
        0
      ),
    [filteredHistory]
  );

  const handleDateSelect = (date) => {
    if (date !== "Custom") {
      setCustomStartDate("");
      setCustomEndDate("");
      setSelectedDate(date);
    } else {
      setSelectedDate(date);
    }
  };

  // Apply Pagination AFTER filtering
  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const changedHistory = filteredHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleCopyId = (copydata) => {
    navigator.clipboard.writeText(copydata || "");
    toast.success("copied!");
  };

  const handleFilterChange = (filters) => {
    console.log("Received from child:", filters);
    setCustomStartDate(filters?.customStartDate);
    setCustomEndDate(filters?.customEndDate);
    handleDateSelect(filters?.selectedDate);
    setCurrentPage(1)
  };
  const handleFilterChangeStatus = (filters) => {
    console.log("Received from child:", filters);
    setSelectedStatus(filters)
    setCurrentPage(1)
  }

  if (historyLoading) {
    return <Loaders />
  }

  return (
    <>
      <div className="innerDiv_s">
        <div className="topDiv_s">
          <div className="top_left_div_s">
            <div className="top_head_s">
              <div>
                <h4 className="Unique-pl">{data?.UL}</h4>
              </div>
              <div>
                <button
                  className="createLink_s"
                  onClick={() => {
                    navigate("/PaymentLinks/enter");
                  }}
                >
                  {data?.createL}
                </button>
              </div>
            </div>
            <div className="link_div_s">
              <div>
                <p className="link_s">
                  {Clink}
                  <span>
                    {" "}
                    <i
                      className="btn btn-md bi-copy copy_s"
                      style={{ color: "var(--thirdshade-orange)" }}
                      onClick={() => handleCopy(copyClink)}
                    ></i>
                  </span>
                </p>
              </div>
              <div>
                <i
                  className="btn btn-md bi-share-fill share_s"
                  style={{ color: "var(--thirdshade-orange)" }}
                  onClick={() => handleShare(copyClink)}
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="container-paymentlinks">
        <div className="header-paymentlinks">
          <div className="head_s_pl">
            <div className="search-container">
              <SearchIcon
                style={{ color: "var(--thirdshade-orange)" }}
                className="search-icon"
              />
              <input
                type="text"
                placeholder="Search by Name or Amount"
                className="search"
                onChange={handleSearch}
                value={searchQuery}
              />
            </div>

            <div className="filters">
              <StatusFilter
                onFilterChange={handleFilterChangeStatus}
                activeFilter={activeFilter}
                setActiveFilter={setActiveFilter}
                type="LinkStatus"
              />
              <DateFilter
                onFilterChange={handleFilterChange}
                activeFilter={activeFilter}
                setActiveFilter={setActiveFilter}
              />

            </div>
          </div>
          <div className="history_paymentLink_s">
            <p className="pay_s_history">{selectedDate}</p>
            <p style={{ fontWeight: '700' }} className="pay_s_history">₹ {sumAmount}</p>
          </div>
          <table className="common-table-v">
            <thead className="table-head-color-paylink">
              <tr>
                <th className="customer-name-td">{data?.paidF}</th>
                <th>{data?.link}</th>
                <th>{data?.tID}</th>
                <th>{data?.from}</th>
                <th>{data?.paidV}</th>
                <th>{data?.amount}</th>
                <th>{data?.Date}</th>
                <th>{data?.status}</th>
              </tr>
            </thead>
            <tbody>
              {changedHistory?.length > 0 && changedHistory ? (
                changedHistory.map((item, index) => (
                  <>
                    <tr key={index}>
                      <td
                        className="table-td-paylinks customer-name-td"
                        title={item?.remarks || item?.link_purpose}
                      >
                        <div className="paidFrom_s">
                          <div className="paidFrom_s_icon">
                            <img src={ImagesPath?.PayMentLinks?.moneyReceive} alt="Money receive icon" />
                          </div>
                          <div className="paidFrom_s_text">
                            {item?.customerName}
                            <br />
                            <span className="remarks-text">
                              {item?.remarks?.slice ||
                                item?.link_purpose?.slice(0, 15) + "..."}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="table-td-paylinks">
                        {item?.PayLink ? item?.PayLink?.slice(0, 15) : Clink?.slice(0, 15)}..
                        <span
                          style={{ color: "var(--copy-icon-blue)", cursor: "pointer" }}
                          className="bi-copy"
                          onClick={() => handleCopyId(item?.PayLink || copyClink)}
                        ></span>
                      </td>
                      <td className="table-td-paylinks">
                        {item?.transactionId ? (
                          <>
                            {item?.transactionId?.slice(0, 12)}...
                            <i
                              style={{ color: "var(--copy-icon-blue)", cursor: "pointer" }}
                              className="btn btn-sm bi-copy"
                              onClick={() => handleCopyId(item?.transactionId)}
                              title="Copy transaction ID"
                            ></i>
                          </>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td
                        style={{ textAlign: "left" }}
                        className="table-td-paylinks"
                        title={item?.customerEmail}
                      >
                        {item?.customer_phone}
                        <br />
                        <span className="customer-email-color">
                          {item?.customerEmail?.slice(0, 15)}...
                        </span>
                      </td>
                      <td className="table-td-paylinks">
                        {item?.detailsToSave?.paymentMode ? (
                          <>
                            {item?.detailsToSave?.paymentMode} <br />
                            {item?.detailsToSave?.paymentMethod == "VISA" ? (
                              <img src={ImagesPath?.GetPaidAddamount?.visa} alt="no" />
                            ) : item?.detailsToSave?.paymentMethod ==
                              "RUPAY" ? (
                              <img src={ImagesPath?.GetPaidAddamount?.rupay} alt="no" />
                            ) : item?.detailsToSave?.paymentMethod ==
                              "MASTER" ? (
                              <img src={ImagesPath?.GetPaidAddamount?.master} alt="no" />
                            ) : null}
                          </>
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td
                        style={{ alignItems: "center" }}
                        className={
                          item?.link_payment_status == "success"
                            ? "table-td-paylinks_special"
                            : item?.link_payment_status == "failed"
                              ? "table-td-paylinks_fail"
                              : "table-td-paylinks"
                        }
                      >
                        {item?.link_payment_status == "success"
                          ? `+₹ ${item?.link_amount}`
                          : item?.link_payment_status == "failed"
                            ? `-₹ ${item?.link_amount}`
                            : `₹ ${item?.link_amount}`}
                      </td>
                      <td className="table-td-paylinks">
                        {item?.transactionDate || "N/A"}
                      </td>
                      {/* <div className="table-td-paylinks"> */}
                      <td>
                        <div className={getStatusClass(item?.link_payment_status)}>{item?.link_payment_status?.toUpperCase()}</div>
                      </td>
                      {/* </div> */}
                    </tr>
                    <tr className="separator"></tr>
                  </>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={8}
                    style={{ textAlign: "center", fontWeight: "bold" }}
                  >
                    {data?.noData}
                  </td>
                </tr>
              )}
            </tbody>
          </table>



        </div>

      </div>
      <div className="total-pagination-paylinks-v">
        <div>
          <Select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(e.target.value);
              setCurrentPage(1);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="itemsperpage"
          >
            {recordsPerPageOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="pagination-container-v">
          <button
            className="arrow-button-v"
            onClick={() => {
              const newStart = Math.max(startPage - 1, 1);
              setStartPage(newStart);
              setCurrentPage(newStart);
            }}
            disabled={startPage === 1}
          >
            <ArrowBackIosNewOutlinedIcon style={{ fontSize: 18 }} />
          </button>

          {[...Array(3)].map((_, idx) => {
            const page = startPage + idx;
            if (page > totalPages) return null;

            return (
              <button
                key={page}
                className={`page-button-v ${currentPage === page ? "active" : ""}`}
                onClick={() => {
                  setCurrentPage(page);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                {page}
              </button>
            );
          })}

          <button
            className="arrow-button-v"
            onClick={() => {
              const newStart = startPage + 1 <= totalPages - 2 ? startPage + 1 : startPage;
              setStartPage(newStart);
              setCurrentPage(newStart);
            }}
            disabled={startPage + 2 >= totalPages}
          >
            <ArrowForwardIosOutlinedIcon style={{ fontSize: 18 }} />
          </button>
        </div>
      </div>
      <div></div>
    </>
  );
};

export default PaymentLinks;



